var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPlay(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.05 14.3114L11.04 3.29389C10.7364 3.10795 10.3886 3.00645 10.0326 2.99985C9.67661 2.99326 9.32532 3.08182 9.015 3.25639C8.70764 3.42824 8.4516 3.67886 8.2732 3.98247C8.09481 4.28609 8.00051 4.63174 8 4.98389V27.0164C8.00232 27.5446 8.21429 28.0503 8.58933 28.4223C8.96437 28.7943 9.47177 29.0021 10 29.0001C10.3687 29 10.7302 28.8983 11.045 28.7064L29.05 17.6889C29.3394 17.5125 29.5786 17.2646 29.7446 16.9691C29.9105 16.6736 29.9977 16.3403 29.9977 16.0014C29.9977 15.6624 29.9105 15.3292 29.7446 15.0337C29.5786 14.7382 29.3394 14.4903 29.05 14.3139V14.3114ZM10 26.9926V5.00014L27.9788 16.0001L10 26.9926Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlay);
export default __webpack_public_path__ + "static/media/play.0b0e1f675ae518add993cd035fc5f5b6.svg";
export { ForwardRef as ReactComponent };